'use client';
import { jsx } from 'react/jsx-runtime';
import { useListBox } from '@react-aria/listbox';
import { useEffect } from 'react';
import { useSwanListboxListContext } from './listbox-list.context.js';
import { ListboxOptionInternal } from './listbox-option-internal.component.js';
import { ListboxSectionInternal } from './listbox-section-internal.component.js';
import { useCollectionContext } from '../../contexts/internal/collection/collection.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useSwanPopover } from '../popover/popover.context.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
const ListboxList = renderWithRef('ListboxList', null, (n, a)=>{
    let { children: b, className: m, 'aria-label': f } = n, { setChildItems: u } = useCollectionContext(), { overlayState: y } = useSwanPopover(), { listProps: O, listState: j, listboxRef: _ } = useSwanListboxListContext();
    useEffect(()=>{
        u(()=>b);
    }, [
        u,
        b
    ]);
    let { listBoxProps: d } = useListBox(_object_spread_props(_object_spread({}, O), {
        'aria-label': f
    }), j, _), w = assignRefs(a, _), x = new Set([
        'swan-listbox-list'
    ]);
    return m && x.add(m), jsx("ul", _object_spread_props(_object_spread({}, n, d), {
        ref: w,
        className: [
            ...x
        ].join(' '),
        children: y.isOpen ? [
            ...j.collection
        ].map((t)=>'section' === t.type ? jsx(ListboxSectionInternal, {
                section: t,
                state: j
            }, t.key) : jsx(ListboxOptionInternal, {
                item: t,
                state: j
            }, t.key)) : null
    }));
});

export { ListboxList };
